import { render, staticRenderFns } from "./transactionFlowBankFile.vue?vue&type=template&id=50ebaff6&scoped=true&"
import script from "./transactionFlowBankFile.vue?vue&type=script&lang=js&"
export * from "./transactionFlowBankFile.vue?vue&type=script&lang=js&"
import style0 from "./transactionFlowBankFile.vue?vue&type=style&index=0&id=50ebaff6&scoped=true&lang=css&"
import style1 from "./transactionFlowBankFile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ebaff6",
  null
  
)

export default component.exports